const CA_PROFILE_URL =                          'CA_PROFILE_URL';
const CONTACT_US =                              'CONTACT_US';
const CHAT =                                    'CHAT';
const CHAT_NOT_LOGIN_EN =                       'CHAT_NOT_LOGIN_EN';
const CHAT_NOT_LOGIN_ES =                       'CHAT_NOT_LOGIN_ES';
const CHAT_LOGIN_EN =                           'CHAT_LOGIN_EN';
const CHAT_LOGIN_ES =                           'CHAT_LOGIN_ES';
const ENTITY_SIGNUP =                           'ENTITY_SIGNUP';
const LOGIN =                                   'LOGIN';
const LOGOUT =                                  'LOGOUT';
const SETTINGS =                                'SETTINGS';
const PHONE =                                   'PHONE';
const MANAGE_ASSISTER =                         'MANAGE_ASSISTER';
const HELP =                                    'HELP';
const AGENT_BROKER_SIGNUP =                     'AGENT_BROKER_SIGNUP';
const UNREAD_MESSAGES =                         'UNREAD_MESSAGES';
const NEW_INBOX_HOME =                          'NEW_INBOX_HOME';
const INBOX_HOME =                              'INBOX_HOME';
const PRIVACY_POLICY =                          'PRIVACY_POLICY';
const ASSISTANCE =                              'ASSISTANCE';
const DASHBOARD =                               'DASHBOARD';
const CALHEERS_URL =                            'CALHEERS_URL';
const HOME =                                    'HOME';
const LANGUAGE =                                'LANGUAGE';
const KEYSTONE_SETTINGS =                       'KEYSTONE_SETTINGS';
const REGISTRATION_LINK =                       'REGISTRATION_LINK';
const FORGOT_USERNAME =                         'FORGOT_USERNAME';
const FORGOT_PASSWORD =                         'FORGOT_PASSWORD';
const MY_ELIGIBILITY_HOME =                     'MY_ELIGIBILITY_HOME';
const PRE_OEP_LANDING =                         'PRE_OEP_LANDING';

export const ENVIRONMENT_LINK_ENDPOINTS_NAMES = {
    CA_PROFILE_URL,
    CONTACT_US,
    CHAT,
    CHAT_NOT_LOGIN_EN,
    CHAT_NOT_LOGIN_ES,
    CHAT_LOGIN_EN,
    CHAT_LOGIN_ES,
    ENTITY_SIGNUP,
    LOGIN,
    LOGOUT,
    SETTINGS,
    PHONE,
    MANAGE_ASSISTER,
    HELP,
    AGENT_BROKER_SIGNUP,
    UNREAD_MESSAGES,
    INBOX_HOME,
    NEW_INBOX_HOME,
    PRIVACY_POLICY,
    ASSISTANCE,
    DASHBOARD,
    CALHEERS_URL,
    HOME,
    LANGUAGE,
    KEYSTONE_SETTINGS,
    REGISTRATION_LINK,
    FORGOT_USERNAME,
    FORGOT_PASSWORD,
    MY_ELIGIBILITY_HOME,
    PRE_OEP_LANDING
};